const NETWORK_SESSION_KEY = "hene.net.sessionId";
const NETWORK_NAME_KEY = "hene.net.playerName";
const NETWORK_CHARACTER_KEY = "hene.net.characterId";
const SESSION_ID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isValidSessionId(sessionId) {
  if (typeof sessionId !== "string") return false;
  return SESSION_ID_RE.test(sessionId.trim());
}

export function readSessionId() {
  try {
    const stored = globalThis.localStorage?.getItem(NETWORK_SESSION_KEY) || null;
    if (isValidSessionId(stored)) return stored.trim().toLowerCase();
  } catch {
    // no-op
  }
  return null;
}

export function writeSessionId(sessionId) {
  try {
    if (isValidSessionId(sessionId)) {
      localStorage.setItem(NETWORK_SESSION_KEY, sessionId.trim().toLowerCase());
    }
  } catch {
    // no-op
  }
}

export function readPlayerName() {
  const fromGlobal = typeof globalThis.HENE_PLAYER_NAME === "string" ? globalThis.HENE_PLAYER_NAME.trim() : "";
  if (fromGlobal) return fromGlobal.slice(0, 24);
  try {
    const stored = globalThis.localStorage?.getItem?.(NETWORK_NAME_KEY)?.trim();
    if (stored) return stored.slice(0, 24);
  } catch {
    // no-op
  }
  return "Player";
}

export function readSelectedCharacter(sanitizeCharacterId, defaultCharacterId) {
  const fromGlobal = typeof globalThis.HENE_CHARACTER_ID === "string" ? globalThis.HENE_CHARACTER_ID.trim() : "";
  if (fromGlobal) return sanitizeCharacterId(fromGlobal);
  try {
    const stored = globalThis.localStorage?.getItem?.(NETWORK_CHARACTER_KEY)?.trim();
    if (stored) return sanitizeCharacterId(stored);
  } catch {
    // no-op
  }
  return defaultCharacterId;
}

export {
  NETWORK_SESSION_KEY,
  NETWORK_NAME_KEY,
  NETWORK_CHARACTER_KEY,
};
